import { HolidayDetailsEdit } from './components/holiday-details/components/holiday-details-edit';
import { HolidayDetailsInfo } from './components/holiday-details/components/holiday-details-info';
import { LocationEdit } from './components/holiday-details/components/location-edit';

export const HOLIDAY_MANAGER_MODALS = {
  deleteGroup: 'deleteGroup',
  editGroup: 'editGroup',
  createGroup: 'createGroup',
  useExistedGroup: 'useExistedGroup',
  createLocation: 'createLocation',
};

export const HOLIDAY_MANAGER_PAGES = {
  edit: 'edit',
  details: 'details',
  locationEdit: 'locationEdit',
};

export const HOLIDAY_MANAGER_PAGE_COMPONENTS = {
  [HOLIDAY_MANAGER_PAGES.edit]: HolidayDetailsEdit,
  [HOLIDAY_MANAGER_PAGES.details]: HolidayDetailsInfo,
  [HOLIDAY_MANAGER_PAGES.locationEdit]: LocationEdit,
};

export type TargetIds = {
  holidayLocationId?: string;
  holidayGroupId?: string;
  holidaySubGroupId?: string;
};
